import { AutocompleteItem } from '@delmonicos/shared-design-system-react/src/components/autocomplete-input/autocomplete-input.component';
import { useMemo, useState } from 'react';

import {
  useCpmsBoGetChargePointQuery,
  useCpmsBoGetChargePointsPaginatedQuery,
} from '@app/core/service/cpms-bo-charge-point.service';

export const useChargePointAutocomplete = (
  networkId: string | undefined,
  selectedChargePointId: string | undefined,
): {
  search: string;
  setSearch: (search: string) => void;
  selectedItem: AutocompleteItem | null;
  autocompleteItems: AutocompleteItem[];
} => {
  const [search, setSearch] = useState<string>('');

  const { data, isSuccess } = useCpmsBoGetChargePointsPaginatedQuery(
    {
      offset: 0,
      limit: 10,
      networkId,
      identity: search === '' ? undefined : `~${search}`,
    },
    { skip: !networkId },
  );

  // Resolved independently from the paginated search results — the
  // selected charge point may not be among the first page of matches.
  const { data: selectedChargePoint, isSuccess: selectedChargePointIsSuccess } =
    useCpmsBoGetChargePointQuery(selectedChargePointId as string, {
      skip: !selectedChargePointId,
    });

  const selectedItem = useMemo<AutocompleteItem | null>(() => {
    if (!selectedChargePointId || !selectedChargePointIsSuccess) {
      return null;
    }

    return {
      key: selectedChargePoint.id,
      label: selectedChargePoint.identity,
    };
  }, [
    selectedChargePointId,
    selectedChargePoint,
    selectedChargePointIsSuccess,
  ]);

  const autocompleteItems = useMemo<AutocompleteItem[]>(() => {
    if (!isSuccess) {
      return [];
    }

    return data.docs.map(({ id, identity }) => ({ key: id, label: identity }));
  }, [data, isSuccess]);

  return { search, setSearch, selectedItem, autocompleteItems };
};
